// input format: dd/mm/yyyy hh:mm:ss
export const stringToDate = (strDate) => {
    const ddmmyyyy = strDate.split(" ")[0]
    const arr = ddmmyyyy.split("/")

}

// Tính số năm giữa date2 - date1
// Trường hợp date1 lớn hơn date2 => Kết quả là số âm.
export const calculateYearsBetweenDates = (date1, date2) => {
    // Lấy phần năm của cả hai ngày
    const yearsDifference = date2.getFullYear() - date1.getFullYear();

    // Kiểm tra xem tháng và ngày của `date1` có trước `date2` hay không, nếu có thì trừ 1
    const isBeforeDate2 = (date2.getMonth() < date1.getMonth()) ||
        (date2.getMonth() === date1.getMonth() && date2.getDate() < date1.getDate());

    // Nếu `date1` chưa đến thời điểm tương ứng trong năm hiện tại của `date2`, trừ 1 năm
    return isBeforeDate2 ? yearsDifference - 1 : yearsDifference;
}

export const convertVNDateTimeToDate = (dateString) => {
    if (!dateString || dateString.trim() === "") {
        return null; // Trả về null nếu chuỗi ngày là null hoặc trống
    }

    const [datePart, timePart] = dateString.split(' ');  // Tách phần ngày và giờ
    const [day, month, year] = datePart.split('/');      // Tách ngày, tháng, năm
    const [hours, minutes, seconds] = timePart.split(':'); // Tách giờ, phút, giây

    // Tạo đối tượng Date với thứ tự year, month (0-based), day, hours, minutes, seconds
    return new Date(year, month - 1, day, hours, minutes, seconds);
}


// Convert to yyyy-mm-dd format
export const convertVNDateTimeToYYYYMMDD = (strdate) => {
    if (strdate) {
        const date = convertVNDateTimeToDate(strdate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    return ''
}

